export type FieldItem = {
  show?: (...args: any[]) => boolean;
  label: string;
  formKey: string;
  fieldFormType:
    | "Radio"
    | "Checkbox"
    | "Switch"
    | "Text"
    | "Email"
    | "Textarea"
    | "Number"
    | "Tags"
    | "AutoComplete"
    | "Dropdown"
    | "MultiSelect"
    | "Datepicker"
    | "Custom";
  optionKey?: string;
  groupKey?: string;
  required?: boolean;
  disabled?: boolean | ((...args: any[]) => boolean);
  maxlength?: number;
  minlength?: number;
  max?: number;
  min?: number;
  step?: number;
  decimals?: number;
  format?: string | false;
  tooltip?: string;
  validator?: (value: any, field: FieldItem) => boolean;
  onInput?: (value: any, field: FieldItem, ...args: any[]) => void;
  onChange?: (value: any, field: FieldItem, ...args: any[]) => void;
  onFocus?: (field: FieldItem, ...args: any[]) => void;
  onBlur?: (field: FieldItem, ...args: any[]) => void;
};

export type SectionItem = {
  show?: (...args: any[]) => boolean;
  customKey?: string;
  title: string;
  fields: FieldItem[];
};

export function filterShowSection(sections: SectionItem[]): SectionItem[] {
  return sections
    .filter((section) => !section.show || section.show())
    .map((section) => ({
      ...section,
      fields: section.fields.filter((field) => !field.show || field.show()),
    }));
}

export const EmailPattern =
  /^(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
